import VCounter from './VCounter';
export { VCounter };
export default VCounter;
//# sourceMappingURL=index.js.map